module.exports = __webpack_public_path__ + "static/media/clock.b284f8d5.gif";